import React, { FunctionComponent } from "react";
import { Box, Text } from "grommet";
import StandardColors from "../../../../../util/StandardColors";
import StandardFonts from "../../../../../util/StandardFonts";
import { MedicalEmergencyStatusType } from "./MedicalEmergencyStatusType";

type StatusChipsPropsType = {
  status?: MedicalEmergencyStatusType;
  borderR?: number;
  showLabel?: boolean; // This will control the visibility of the label
};

const statusColorMapping = {
  NOTIFIED: {
    backgroundColor: StandardColors.secondary_red_20,
    fontColor: StandardColors.secondary_red_100,
  },
  MONITORING: {
    backgroundColor: "#FFE3E3",
    fontColor: "#FD7272",
  },
  EMERGENCY_CARE_REQUIRED: {
    backgroundColor: StandardColors.secondary_red_20,
    fontColor: StandardColors.secondary_red_100,
  },
  RESOLVED: {
    backgroundColor: "#5CD292",
    fontColor: StandardColors.white,
  },
  CONTINUE_AND_MONITOR: {
    backgroundColor: "#D1F9E4",
    fontColor: "#5CD292",
  },
} as { [key: string]: { fontColor: string; backgroundColor: string } };

const StatusChip: FunctionComponent<StatusChipsPropsType> = ({
  status, borderR, showLabel = false // Default showLabel to false
}: StatusChipsPropsType) => {
  let transformedStatus;
  transformedStatus = status
    ?.split("_")
    .map((word_) => {
      let word;
      if (word_ != null || word_ != undefined) {
        word = word_.toLocaleLowerCase();
      }
      if (word != null || word != undefined) {
        return word.charAt(0).toLocaleUpperCase() + word.slice(1);
      }
    })
    .join(" ");

  const styles = {
    container: {
      alignItems: "center",
      justifyContent: "center",
      borderRadius: borderR ? borderR : 8,
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12,
    },
    textStyle: {
      ...StandardFonts.capture1016Medium,
      textAlign: "center",
      fontSize: 12,
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: 15
    },
  };

  return (
    <Box
      style={{
        ...styles.container,
        backgroundColor: statusColorMapping[status ? status : ""].backgroundColor,
      }}
    >
      <Text
        style={{
          lineHeight: "15px",
          fontFamily: "Inter",
          textAlign: "center",
          fontSize: 12,
          fontStyle: "normal",
          fontWeight: "500",
          color: statusColorMapping[status ? status : ""].fontColor,
        }}
      >
        {showLabel && (
          <Text style={{ fontSize: "13px", fontWeight: "bold", marginRight: 5 }}>
            Incident Status:
          </Text>
        )}
        {transformedStatus}
      </Text>
    </Box>
  );
};

StatusChip.defaultProps = {
  status: "NOTIFIED",
  showLabel: false, // Default to false
};

export default StatusChip;
